import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Model"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.6251 3H6.37511L1.28711 9.78375L12.0001 22.1453L22.7131 9.78375L17.6251 3ZM20.2501 9H16.1656L13.3531 4.5H16.8751L20.2501 9ZM7.7267 10.5L10.5422 18.1725L3.8927 10.5H7.7267ZM9.32415 10.5H14.6762L11.9994 17.7907L9.32415 10.5ZM9.60389 9.00001L12.0001 5.16526L14.3971 9.00001H9.60389ZM16.2737 10.5H20.1077L13.4575 18.1732L16.2737 10.5ZM7.12506 4.5H10.6471L7.83456 9H3.75006L7.12506 4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Model.vue"]]);
